import { ReactComponent as Redes } from '../../assets/icons/redesSociales.svg'
import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg'
import { ReactComponent as Instagram } from '../../assets/icons/instagram.svg'
import { ReactComponent as LinkedIn } from '../../assets/icons/linkedin.svg'
import { ReactComponent as X } from '../../assets/icons/x.svg'
import { ReactComponent as WhatsApp } from '../../assets/icons/whatsapp.svg'
import { ReactComponent as Correo } from '../../assets/icons/mail.svg'
import { ReactComponent as GooglePlus } from '../../assets/icons/google+.svg'
import { ReactComponent as Youtube } from '../../assets/icons/youtube.svg'
import { ReactComponent as Web } from '../../assets/icons/web.svg'
import { ReactComponent as Editar } from '../../assets/icons/editar.svg';
import SvgIcon from '../../utils/Icon';
import apiClient from '../../utils/axiosPetition'
import { useEffect, useState } from 'react'
import { alertaGeneral } from '../../utils/alertas'

const RedesSociales = ({ redesSociales, isPatient = true, userId }) => {
    const [isEdit, setIsEdit] = useState(false);
    const [redesSocialesState, setRedesSocialesState] = useState(redesSociales);
    const [redesCopy, setRedesCopy] = useState(redesSociales);
    const colorIcon = isEdit ? 'text-[#205087ff] scale-110' : 'text-white';
    const axiosPetition = `/api/${isPatient ? 'patient' : 'doctor'}/updateSocialMedia/${userId}`;

    const updateRedesSociales = () => {
        apiClient.put(axiosPetition, redesSocialesState)
            .then((response) => {
                if (response.status === 200) {
                    setRedesCopy(redesSocialesState);
                    setIsEdit(false);
                    alertaGeneral({
                        titulo: 'Éxito',
                        messageHtml: 'Redes sociales actualizadas correctamente',
                    });
                }
            })
            .catch((error) => {
                alertaGeneral({
                    titulo: 'Error',
                    messageHtml: error?.response?.data?.message || 'Ocurrió un error al actualizar las redes sociales',
                    isError: true
                });
            })
    }

    useEffect(()=> {
        if(!isEdit){
            setRedesSocialesState({...redesCopy});
        }
    }, [isEdit]);

    const onHandleChange = (e) => {
        setRedesSocialesState({
            ...redesSocialesState,
            [e.target.name]: e.target.value
        });
    }

    const onClickInput = (e) => {
        if (!isEdit && e.target.value !== '') {
            const url = e.target.value.startsWith('http') ? e.target.value : `https://${e.target.value}`;
            window.open(url, '_blank');
        }
    }

    return (
        <div className="">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="bg-[#1f94c2ff] px-4 py-1.5 border-b border-[#205087ff]">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center">
                            <SvgIcon Icon={Redes} className={"w-5 h-5 text-white mr-2 shrink-0"} /> 
                            <span className="text-white font-semibold text-sm">Redes sociales</span>
                        </div>
                        <span className="flex items-center space-x-2">
                            {!isEdit ? (
                                <button
                                    type="button"
                                    className="flex items-center gap-1.5 px-2.5 py-1 rounded-full cursor-pointer transition-all duration-200 shrink-0 bg-white/20 hover:bg-white/30 text-white"
                                    onClick={() => setIsEdit(true)}
                                    title="Editar redes sociales"
                                >
                                    <SvgIcon Icon={Editar} className="w-5 h-5" />
                                    <span className="text-sm font-medium">Editar</span>
                                </button>
                            ) : (
                                <>
                                    <span className="text-sm text-white/90 font-medium hidden sm:inline">Editando</span>
                                    <button
                                        type="button"
                                        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full cursor-pointer transition-all duration-200 shrink-0 bg-white text-[#205087ff] shadow-md"
                                        title="Modo edición activo"
                                        aria-current="true"
                                    >
                                        <SvgIcon Icon={Editar} className="w-5 h-5" />
                                        <span className="text-sm font-medium">Editar</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full cursor-pointer transition-all duration-200 shrink-0 bg-white/20 hover:bg-white/30 text-white"
                                        onClick={updateRedesSociales}
                                        title="Guardar cambios"
                                    >
                                        <span className="text-sm font-medium">Guardar</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full cursor-pointer transition-all duration-200 shrink-0 bg-white/20 hover:bg-white/30 text-white"
                                        onClick={() => setIsEdit(false)}
                                        title="Cancelar edición"
                                    >
                                        <span className="text-sm font-medium">Cancelar</span>
                                    </button>
                                </>
                            )}
                        </span>
                    </div>
                </div>

                <div className="bg-white p-4">
                {isEdit && (
                    <div className="mb-2 p-2 bg-blue-50 border-l-4 border-[#1f94c2ff] rounded">
                        <p className="text-sm text-[#1f94c2ff] font-medium">
                            ✏️ Modo edición activo - Puedes editar todos los campos
                        </p>
                    </div>
                )}
                <form className="w-full gap-3 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">

                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={Facebook} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="facebook"
                            readOnly={!isEdit}
                            value={redesSocialesState?.facebook || ''}
                            onChange={onHandleChange}
                            onClick={onClickInput}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="URL de Facebook"
                        />
                    </div>

                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={Instagram} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="instagram"
                            readOnly={!isEdit}
                            value={redesSocialesState?.instagram || ''}
                            onChange={onHandleChange}
                            onClick={onClickInput}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="URL de Instagram"
                        />
                    </div>
                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={LinkedIn} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="linkedin"
                            readOnly={!isEdit}
                            value={redesSocialesState?.linkedin || ''}
                            onChange={onHandleChange}
                            onClick={onClickInput}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="URL de LinkedIn"
                        />
                    </div>
                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={X} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="twitter"
                            readOnly={!isEdit}
                            value={redesSocialesState?.twitter || ''}
                            onChange={onHandleChange}
                            onClick={onClickInput}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="URL de Twitter/X"
                        />
                    </div>

                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={WhatsApp} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="whatsapp"
                            readOnly={!isEdit}
                            value={redesSocialesState?.whatsapp || ''}
                            onChange={onHandleChange}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="Número de WhatsApp"
                        />
                    </div>

                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={Correo} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="correoContacto"
                            readOnly={!isEdit}
                            value={redesSocialesState?.correoContacto || ''}
                            onChange={onHandleChange}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="Correo de contacto"
                        />
                    </div>

                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={GooglePlus} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="googlePlus"
                            readOnly={!isEdit}
                            value={redesSocialesState?.googlePlus || ''}
                            onChange={onHandleChange}
                            onClick={onClickInput}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="URL de Google+"
                        />
                    </div>

                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={Youtube} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="youtube"
                            readOnly={!isEdit}
                            value={redesSocialesState?.youtube || ''}
                            onChange={onHandleChange}
                            onClick={onClickInput}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="URL de YouTube"
                        />
                    </div>

                    <div className="flex items-center">
                        <div className="bg-[#1f94c2ff] flex items-center justify-center px-3 py-3 rounded-l border border-[#1f94c2ff]">
                            <SvgIcon Icon={Web} className="w-4 h-4 text-white" />
                        </div>
                        <input
                            type="text"
                            name="web"
                            readOnly={!isEdit}
                            value={redesSocialesState?.web || ''}
                            onChange={onHandleChange}
                            onClick={onClickInput}
                            className={`flex-1 px-4 py-3 text-base border rounded-r focus:outline-none transition-all duration-200 ${
                                isEdit 
                                    ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent' 
                                    : 'bg-gray-50 border border-gray-300 cursor-pointer focus:ring-2 focus:ring-[#1f94c2ff] focus:border-transparent'
                            }`}
                            placeholder="URL de sitio web"
                        />
                    </div>
                </form>
                </div>
            </div>
        </div>
    );
}

export default RedesSociales;